/** @format */

import { ThunkDispatch } from "@reduxjs/toolkit";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { useAppSelector } from "../../app/hooks";
import { useGetUserResourceQuery } from "../../app/services/userResource/userResourcesApi";
import BLSpinner from "../../assets/animations/BLSpinner/BLSpinner";
import { useLocale } from "../i18n/hooks";
import PageNotFound from "../pageNotFound/PageNotFound";
import ResourceUI from "./ResourceUI";
import { setIsEditable } from "../editable/editableSlice";

const UserResource: React.FC = () => {
  const locale = useLocale();
  const dispatch = useDispatch<ThunkDispatch<any, string, any>>();

  const { resourceId, userId, copy } = useParams();

  const user = useAppSelector((state) => state.auth.userInfo);
  const isStaff = useAppSelector((state) => state.auth.isStaff);

  // Get UserResource
  const { data: userResource, isFetching: isFetchingResource } =
    useGetUserResourceQuery({
      code: resourceId,
      copy: copy,
      locale: locale,
      email: userId,
    });

  useEffect(() => {
    if (
      (userResource &&
        user?.emailHash !== undefined &&
        user?.emailHash === userResource.UserEmailHash) ||
      isStaff
    ) {
      dispatch(setIsEditable(true));
    }

    return () => {
      dispatch(setIsEditable(false));
    };
  }, [user, userResource, isStaff, dispatch]);

  return (
    <>
      {isFetchingResource ? (
        <BLSpinner
          className="position-absolute top-50 start-50 translate-middle"
          size="3rem"
        />
      ) : userResource ? (
        <ResourceUI resource={userResource} />
      ) : (
        <PageNotFound itemName="Page" />
      )}
    </>
  );
};

export default UserResource;
